// libs/embed-libs/react-embed/src/lib/luzmo-dashboard.tsx
import * as React from "react";
import { createComponent } from "@lit/react";
import { LuzmoDashboard } from "@luzmo/embed";

// libs/embed-libs/react-embed/package.json
var package_default = {
  name: "@luzmo/react-embed",
  version: "5.0.10",
  typings: "./index.d.ts",
  dependencies: {
    "@lit/react": "1.0.3",
    "@luzmo/embed": "5.0.11"
  },
  peerDependencies: {
    react: "^16 || ^17 || ^18",
    "react-dom": "^16 || ^17 || ^18"
  },
  keywords: [
    "react",
    "react-luzmo",
    "luzmo",
    "front-end",
    "development",
    "dashboard",
    "visualization",
    "chart",
    "cumul.io",
    "component"
  ]
};

// libs/embed-libs/react-embed/src/lib/luzmo-dashboard.tsx
var LuzmoDashboardComponent = createComponent({
  react: React,
  tagName: "luzmo-dashboard",
  elementClass: LuzmoDashboard,
  events: {
    itemsRendered: "itemsRendered",
    load: "load",
    changedFilters: "changedFilters",
    customEvent: "customEvent",
    exported: "exported",
    dashboardAction: "dashboardAction"
  }
});
LuzmoDashboardComponent.defaultProps = {
  VERSION: package_default.version + "-react-luzmo"
};
export {
  LuzmoDashboardComponent
};
